import WarningIcon from '../../../icons/WarningIcon';
import i18n from '../../../common/i18n';
import React from 'react';
import './NikePlayerError.less';
import clsx from 'clsx';

export const NikePlayerError = ({
    msg = i18n('nui.video.unavailable'),
    debug,
    fill = false
}: {
    msg?: string;
    debug?: Record<string, any>;
    fill?: boolean;
}) => {
    return (
        <div
            className={clsx('nui-nike-player-error-bg p-rel full-width', { 'nui-nike-player-error-wrapper': !fill })}
            data-atid={'nike-player-error'}
        >
            <p style={{ display: 'none' }}>DEBUG: {JSON.stringify(debug, undefined, 4)}</p>
            <div
                className={
                    'nui-nike-player-error-msg flex flex-col c-black-10 fs-16 items-center justify-center p-abs text-center px-20'
                }
            >
                <div className={'py-5'}>
                    <WarningIcon width={30} height={30} fill={'brown'} />
                </div>
                {msg}
            </div>
        </div>
    );
};
